import { type Components, type Theme } from "@mui/material/styles";

export const accordionSummary: Components<Theme>["MuiAccordionSummary"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      mb: 0,
      backgroundColor: theme.palette.whiteStates.main,
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
      borderRadius: "12px 12px 0 0",
      "&:first-of-type": {
        borderRadius: "12px 12px 0 0",
      },
    }),
  },
};
